// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_XxHWhsUyOMVRLbZhyyRm {
  width: 100%;
}

.style-module_helperText_w1pBPrSLUVAABxR_orKd {
  font-size: 0.75rem;
  color: var(--text-02);
  line-height: 1.5;
  z-index: 0;
  max-height: 3rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/style.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n}\n\n.helperText { \n  font-size: 0.75rem;\n  color: var(--text-02);\n  line-height: 1.5;\n  z-index: 0;\n  max-height: 3rem;\n  margin-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_XxHWhsUyOMVRLbZhyyRm`,
	"helperText": `style-module_helperText_w1pBPrSLUVAABxR_orKd`
};
export default ___CSS_LOADER_EXPORT___;
